var React = require('react');

function DifficultyLevelBlack3 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.3981 0.860107L11.1587 8.13378L5.92022 0.860107L0.159912 8.86011L5.92022 16.8601L11.1587 9.58644L16.3981 16.8601L22.1599 8.86011L16.3981 0.860107Z","fill":"black","key":0}),React.createElement("path",{"d":"M7.64729 5.62061V6.57076H5.47973V8.0879H7.47776V9.03806H5.47973V10.8213H7.71698V11.784H4.13508V5.62061H7.64729Z","fill":"white","key":1}),React.createElement("path",{"d":"M15.6154 5.62061L16.525 7.64618L17.4346 5.62061H18.8319L17.2302 8.66674L18.8582 11.784H17.3348L16.347 9.65841L15.3592 11.784H13.9665L15.6332 8.55853L14.0834 5.62061H15.6154Z","fill":"white","key":2})]);
}

DifficultyLevelBlack3.defaultProps = {"viewBox":"0 0 23 17","fill":"none"};

module.exports = DifficultyLevelBlack3;

DifficultyLevelBlack3.default = DifficultyLevelBlack3;
